export default __webpack_public_path__ + "static/media/avatar-pro.64674cbd.png";